var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideSwitch)?_c('oie-header-switch',{attrs:{"is-for":_vm.isFor,"value":_vm.useVat,"label-text":_vm.tStatic('showPricesWithVat')},on:{"toggle":function($event){return _vm.toggleCheckbox($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }